import type React from 'react';
import { useState } from 'react';
import { Modal, KovResourcePicker } from '@kathondvla/react-shared-components/src/components';
import { escapeRegExp } from 'lodash';
import {
  type Concordantie,
  selectFormattedOdetChildren,
} from '@UI/aside/asideConcordanties/asideConcordantiesSelectors';
import { useTypedSelector } from '../../hooks/useTypedSelector';

export interface ConcordantieModalProps {
  onClose?: () => void;
  onSubmit?: (response: { endterms: Concordantie | undefined }) => void;
  concordantie?: Concordantie;
}
const filterFn = ({ data }, str) => {
  if (!str || str.trim().length === 0) {
    return true;
  }
  const regExp = new RegExp(escapeRegExp(str), 'gi');
  return regExp.test(data.display);
};

const ConcordantieModal: React.FC<ConcordantieModalProps> = ({
  onClose = () => {},
  onSubmit,
  concordantie,
}) => {
  const odetChildren = useTypedSelector((state) => selectFormattedOdetChildren(state));
  const [selectedConcordanties, setSelectedConcordanties] = useState<Concordantie | undefined>(
    concordantie
  );

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit({ endterms: selectedConcordanties });
      onClose();
    }
  };

  return (
    <div className="overflown-modal">
      <Modal.Header title="Voeg gerelateerd document toe" onClose={onClose} />
      <Modal.Body>
        <div className="form-group">
          <KovResourcePicker
            value={selectedConcordanties}
            localData={odetChildren}
            clearable={false}
            onChange={setSelectedConcordanties}
            filter={filterFn}
            menuPlacement="bottom"
            disableSearch={false}
            optionValue={(o) => o.contentKey || o.key}
            optionTemplate={(o) =>
              o.display || `${o.goalIdentifier ? `${o.goalIdentifier} - ` : ''} ${o.title}`
            }
            placeholder="Selecteer een type"
            multiple={!concordantie}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-link pull-left" onClick={onClose}>
          Annuleren
        </button>
        <button type="button" className="btn btn-primary" onClick={handleSubmit}>
          Ok
        </button>
      </Modal.Footer>
    </div>
  );
};

ConcordantieModal.displayName = 'ConcordantieModal';

export default ConcordantieModal;
